<template>
    <div>
        <Listing api="/students" :title="title" :fields="fields" :filters-schema="filtersSchema" :filters="filters" @extra-data="onExtraData">
            <template #cell(genre)="{value}">
                <i class="bx font-size-24" :class="value == 'F' ? 'bx-female text-dark' : 'bx-male text-secondary'" :style="{ opacity: value == 'F' ? 1 : 0.55 }"></i>
            </template>
            <template #cell(filieres)="{value}">
                <div v-for="item in value" :key="item.stagiaireFiliere">
                    {{ item.nom }}<small class="text-muted"> {{ item.anneeScolaire }}</small>
                </div>
            </template>
            <template #cell(enquete)="{value: { count, done }}">
                <b-badge
                    class="py-1 px-2 font-size-11 font-weight-semibold"
                    :class="`bg-soft-${done == 0 ? 'secondary' : count == done ? 'primary' : 'warning'} text-${done == 0 ? 'secondary' : count == done ? 'primary' : 'warning'}`"
                    >{{ done }} / {{ count }}</b-badge
                >
            </template>
        </Listing>
    </div>
</template>

<script>
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Listing from "@/components/listing";

    export default {
        page: {
            title: "Liste des stagiaires",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader,
            Listing
        },
        data: () => ({
            title: "Liste des stagiaires",
            fields: [
                { key: "nom", label: "Nom complet", formatter: (value, key, { nom, prenom }) => `${nom} ${prenom}` },
                { key: "genre" },
                { key: "cef", label: "CEF" },
                { key: "dateNaissance" },
                { key: "tel" },
                { key: "filieres", label: "Filières" },
                {
                    key: "enquete",
                    label: "Enquêtes",
                    formatter: (value, key, { filieres }) => ({ done: filieres.filter(item => item.date).length, count: filieres.length }),
                    thClass: "text-center",
                    tdClass: "text-center w-0"
                }
            ],
            filters: {
                idEfp: localStorage.getItem("selected-efp"),
                typeEfp: localStorage.getItem("selected-efp-type")
            },
            filtersData: {},
            loading: false
        }),
        methods: {
            onEFPChanged(id) {
                this.filters = { ...this.filters, idEfp: id, typeEfp: localStorage.getItem("selected-efp-type") };
            },
            onExtraData(data) {
                this.filtersData = data;
            },
            clearFilters() {
                const idEfp = localStorage.getItem("selected-efp");
                const typeEfp = localStorage.getItem("selected-efp-type");
                this.filters = {
                    idEfp,
                    typeEfp
                };
            }
        },
        mounted() {
            this.mitt.on("efp-changed", this.onEFPChanged);
        },
        beforeDestroy() {
            this.mitt.off("efp-changed", this.onEFPChanged);
        },
        computed: {
            filtersSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "row align-items-end",
                            fields: [
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "CEF",
                                    model: "cef",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Nom complet",
                                    model: "nom",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "multiselect",
                                    label: "Genre",
                                    model: "genre",
                                    styleClasses: "col font-size-12 text-muted",
                                    selectOptions: {},
                                    values: [
                                        { id: "H", nom: "Masculin" },
                                        { id: "F", nom: "Féminin" }
                                    ]
                                },
                                {
                                    type: "multiselect",
                                    label: "Filières",
                                    model: "idFiliere",
                                    styleClasses: "col-4 font-size-12 text-muted",
                                    values: this.filtersData.branchs || []
                                },
                                {
                                    type: "multiselect",
                                    label: "Année scolaire",
                                    model: "idAnnee",
                                    styleClasses: "col font-size-12 text-muted",
                                    values: this.filtersData.years || []
                                },
                                {
                                    type: "submit",
                                    buttonText: "Effacer",
                                    styleClasses: "col-auto",
                                    attributes: {
                                        class: "btn btn-light mb-1"
                                    },
                                    onSubmit: this.clearFilters
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>
